import styled, { css } from 'styled-components';
import { FormContainerFieldSetContainer } from '@anwb/form-container-field-set';
import { LinkContainer } from '@anwb/link';
import { SpinnerContainer } from '@anwb/spinner';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
const LINK_HEIGHT = 44;
export const formContainerFieldContainerStyled = ({ theme }) => css `
	&& {
		//@core-ui override
		display: flex;
		flex-direction: column;
		width: 100%;
		// subtract 6px this is added as a margin to input elements by core-ui
		margin-bottom: ${pxToRem(Number(theme.spacing['400']) - Number(theme.spacing['100']))};
	}

	& > span {
		height: 0;
		margin-top: ${pxToRem(theme.spacing['100'])};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			height: auto;
		}
	}

	& > ${FormContainerFieldFormText} {
		height: auto;
	}

	${FormContainerFieldSetContainer} & {
		max-width: none;

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			flex: 1 1 auto;

			&[data-size='s'] {
				width: 25%;
			}

			&[data-size='m'] {
				min-width: 25%;
				max-width: 50%;
			}

			&[data-size='l'] {
				min-width: 50%;
				max-width: 75%;
			}

			&[data-size='xl'] {
				max-width: 100%;
			}
		}
	}
`;
export const FormContainerFieldContainer = styled.div `
	${formContainerFieldContainerStyled}
`;
export const formContainerFieldWrapperStyled = ({ theme, $size, }) => css `
	display: flex;
	gap: ${pxToRem(theme.spacing['200'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		flex: 1 1 auto;
	}

	${$size === 's' &&
    css `
		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			min-width: 25%;
			max-width: 25%;
		}
	`}

	${$size === 'm' &&
    css `
		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			min-width: 25%;
			max-width: 50%;
		}
	`}

  ${$size === 'l' &&
    css `
		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			min-width: 50%;
			max-width: 75%;
		}
	`}

	${$size === 'xl' &&
    css `
		max-width: 100vw;

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			max-width: 100%;
		}
	`}

	${LinkContainer} {
		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			margin: ${pxToRem(theme.spacing['100'])} 0 ${pxToRem(theme.spacing['100'])}
				${pxToRem(theme.spacing['200'])};
			display: flex;
			align-items: center;
			min-height: ${pxToRem(LINK_HEIGHT)};
		}
	}

	${SpinnerContainer} {
		margin-top: ${pxToRem(Number(theme.spacing['100']) / 2)};
	}

	& > button {
		margin-left: ${pxToRem(theme.spacing['100'])};
		width: auto;
	}

	a {
		margin-top: ${pxToRem(theme.spacing['300'])};
		margin-left: ${pxToRem(theme.spacing['200'])};
	}

	* a {
		margin: 0;
	}
`;
export const FormContainerFieldWrapper = styled.div `
	${formContainerFieldWrapperStyled}
`;
export const formContainerFieldErrorStyles = ({ theme, $colorContext, $disabled, }) => css `
	padding: 0;
	white-space: pre-line;
	color: ${theme.colors.error.textFieldValidation};

	${$colorContext === 'on-dark' &&
    css `
		color: ${theme.colors.error.textFieldValidationInverse};
	`}

	${$disabled &&
    css `
		color: ${theme.colors.medium.textInactive};
	`}
`;
export const FormContainerFieldError = styled(Typography).attrs({
    tagName: 'div',
    variant: 'field-validation',
}) `
	${formContainerFieldErrorStyles}
`;
/**
 * Form Container Field Label
 */
export const formContainerFieldLabelStyles = ({ theme, $colorContext, $disabled, }) => css `
	${$colorContext === 'on-light' &&
    css `
		color: ${theme.colors.base.textLabel};
	`}

	${$colorContext === 'on-medium' &&
    css `
		color: ${theme.colors.base.textLabel};
	`}

	${$colorContext === 'on-dark' &&
    css `
		color: ${theme.colors.blanc.textInverse};
	`}

	${$disabled &&
    css `
		color: ${theme.colors.medium.textInactive};
	`}
`;
export const FormContainerFieldLabel = styled(Typography).attrs({
    tagName: 'label',
    variant: 'label-title',
}) `
	${formContainerFieldLabelStyles}
`;
/**
 * Form Container Field Form Text
 */
export const formContainerFieldFormTextStyles = ({ theme, $colorContext, $color, $disabled, }) => css `
	margin: ${pxToRem(theme.spacing['100'])} 0;

	${$colorContext === 'on-light' &&
    css `
		color: ${theme.colors.base.textSupport};

		${$color === 'success' &&
        css `
			color: ${theme.colors.positive.textSupport};
		`}
		${$color === 'error' &&
        css `
			color: ${theme.colors.error.textFieldValidation};
		`}
			${$color === 'default' &&
        css `
			color: ${theme.colors.base.textSupport};
		`}
	`}

	${$colorContext === 'on-medium' &&
    css `
		color: ${theme.colors.base.textSupport};

		${$color === 'success' &&
        css `
			color: ${theme.colors.positive.textSupport};
		`}
		${$color === 'error' &&
        css `
			color: ${theme.colors.error.textFieldValidation};
		`}
			${$color === 'default' &&
        css `
			color: ${theme.colors.base.textSupport};
		`}
	`}

	${$colorContext === 'on-dark' &&
    css `
		color: ${theme.colors.blanc.textSupportInverse};

		${$color === 'success' &&
        css `
			color: ${theme.colors.positive.textFieldValidationInverse};
		`}
		${$color === 'error' &&
        css `
			color: ${theme.colors.error.textFieldValidationInverse};
		`}
			${$color === 'default' &&
        css `
			color: ${theme.colors.blanc.textSupportInverse};
		`}
	`}

	${$disabled &&
    css `
		color: ${theme.colors.medium.textInactive};
	`}
`;
export const FormContainerFieldFormText = styled(Typography).attrs({
    variant: 'support-text',
}) `
	${formContainerFieldFormTextStyles}
`;
//# sourceMappingURL=form-container-field.styled.js.map